import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {CardStudentContact} from '../card-student-contact';
import {TylerMatTableDataSource} from '../../../../../../shared-components/angular-material/extended.class';
import {detailExpand} from '../../../../../../shared-components/angular-material/mat-animations';
import {SendEmailService} from '../../../../../../shared-modules/send-email/send-email.service';
import {Router} from '@angular/router';

@Component({
    selector: 'tyl-contacts-v10',
    templateUrl: './contacts-v10.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./contacts-v10.component.css'],
    // Animation for when the detail row is expanded or collapsed
    animations: [detailExpand]
})
export class ContactsV10Component implements OnInit {
    @Input() contacts: CardStudentContact[];
    // Angular Material Table
    displayedColumns: string[] = ['contactKey', 'contactSequence', 'name', 'relationship', 'cell', 'more'];
    angularMatData = new TylerMatTableDataSource();

    constructor(private cdr: ChangeDetectorRef, private sendEmailService: SendEmailService, private router: Router) {}

    ngOnInit() {
        if (this.contacts) {
            this.angularMatData.data = this.contacts;
        }
    }

    updateView() {
        this.cdr.detectChanges();
    }

    sendEmail(name: string, emailAddress: string) {
        this.sendEmailService.teacherEmailAddress = emailAddress;
        this.sendEmailService.teacherName = name;
        this.router.navigateByUrl('/student360/sendEmail');
    }

    // ----------Angular Material------------------------------------
    // These methods are used to allow calls to the TylerMatTableDataSource methods from the html
    toggleExpanded(row: any) {
        // Toggles row between expanded and collapsed
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        // Return true if expanded and false if collapsed
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        //  Expand or collapse all rows
        //  true => expand all    false => collapse all
        this.angularMatData.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);
    }

}
